// src/pages/system/SingleCustomCollection/details/ItemFields.jsx
import moment from 'moment'
import { useTranslation } from 'react-i18next'

export default function ItemFields({ item, collectionDetails }) {
	const { t } = useTranslation()
	// console.log(`TCL -> ItemFields.jsx:5 -> ItemFields -> collectionDetails:`, collectionDetails)
	// console.log(`TCL -> ItemFields.jsx:71 -> ItemFields -> item:`, item)

	const toEditorPreview = (content) => {
		if (typeof content !== 'string') return content
		const stripped = content
			.replace(/<[^>]+>/g, ' ')
			.replace(/&nbsp;/g, ' ')
			.replace(/\s+/g, ' ')
			.trim()
		if (!stripped) return '-'
		const words = stripped.split(' ')
		return words.length > 8 ? `${words.slice(0, 8).join(' ')}...` : stripped
	}

	const getFieldType = (fieldName) => {
		const field = collectionDetails.fields.find(f => f.name === fieldName)
		return field ? field.type : 'unknown'
	}

	const getFieldParentCollectionId = (fieldName) => {
		const field = collectionDetails.fields.find(f => f.name === fieldName)
		// console.log(`TCL -> ItemFields.jsx:15 -> getFieldParentCollectionId -> field:`, field)
		return field.lookupCollectionId; 
		
	}

	const getFieldParentCollectionName = (fieldName) => {
		const field = collectionDetails.fields.find(f => f.name === fieldName)
		return field ? field.lookupCollectionName : null
	}

	return (
		<dl className="mt-2 px-6 text-sm/6 grid grid-cols-1 lg:grid-cols-2 gap-x-8">
	
			{Object.entries(item).map(([key, value]) => {
				// Skip internal fields and null/undefined values
				if (key.startsWith('_') || key === '__v' || value == null || key === 'created' || key === 'updated') return null
				let fieldType = getFieldType(key);
				let displayValue = value;
				let itemLink = null;
				if(fieldType === 'lookup' && value?.fieldValue) { 
					let parentCollectionId = getFieldParentCollectionId(key);
					let parentCollectionName = getFieldParentCollectionName(key);

					if (parentCollectionName === "Customers") 
						itemLink = `/system/customers/details/${value.fieldValue}`;
					else 
						itemLink = `/single-custom-collection/${parentCollectionId}/details/${value.fieldValue}`;

					// console.log(`TCL -> ItemFields.jsx:23 -> ItemFields -> itemLink:`, itemLink)
					displayValue = value.fieldName || value.fieldValue; 
				}


				if (fieldType === 'editor') {
					displayValue = toEditorPreview(displayValue)
				}

				return (
					<div key={key} className="py-2 sm:flex">
						<dt className="font-medium text-gray-900 sm:w-32 sm:flex-none sm:pr-4 capitalize">{key}</dt>
						<dd className="mt-1 text-gray-900 sm:mt-0 break-words">
							{fieldType === 'lookup' && itemLink ? (
								<a href={itemLink} className="text-blue-600 hover:underline">{displayValue}</a>
							) : (
								displayValue
							)}
						</dd>
					</div>
				)
			})}
			
			{item.created && (
				<div className="py-2 sm:flex">
					<dt className="font-medium text-gray-900 sm:w-32 sm:flex-none sm:pr-4">{t('singleCustomCollection.details.labels.created')}</dt>
					<dd className="mt-1 text-gray-900 sm:mt-0">{moment(item.createdAt).format('YYYY-MM-DD HH:mm')}</dd>
				</div>
			)}
			
			{item.updated && (
				<div className="py-2 sm:flex">
					<dt className="font-medium text-gray-900 sm:w-32 sm:flex-none sm:pr-4">{t('singleCustomCollection.details.labels.updated')}</dt>
					<dd className="mt-1 text-gray-900 sm:mt-0">{moment(item.updatedAt).format('YYYY-MM-DD HH:mm')}</dd>
				</div>
			)}
		</dl>
	)
}
